import { useState } from 'react';
import * as S from '../Navbar/Navbar.styles';
import { Link } from 'react-router-dom';
import logo from '../Images/Logo.png';
import { SlMenu } from 'react-icons/sl';
import ToggleModeSwitch from './ToggleModeSwitch';

const Navbar = () => {
  const [showMenuBurger, setShowMenuBurger] = useState(false);

  const clickItemNav = (item) => {
    document.getElementById(item).scrollIntoView({ behavior: 'smooth' });
    setShowMenuBurger(false);
  };

  return (
    <S.ContainerNavbar>
      <S.ContainerLogo>
        <div>
          <img src={logo} alt="Logo" />
        </div>
      </S.ContainerLogo>

      <S.ContainerBurger>
        <SlMenu onClick={() => setShowMenuBurger(!showMenuBurger)} />
      </S.ContainerBurger>

      <S.ContainerMenu showMenuBurger={showMenuBurger}>
        <div className="navMenu">
          <ul className="menu">
            <li onClick={() => clickItemNav('start')}>
              <Link className="menuItem" to="/">
                About me
              </Link>
            </li>
            <li onClick={() => clickItemNav('skillsSection')}>
              <Link className="menuItem" to="/skills">
                Skills
              </Link>
            </li>
            <li onClick={() => clickItemNav('projectsSection')}>
              <Link className="menuItem" to="/projects">
                Projects
              </Link>
            </li>
            <li>
              <S.Button onClick={() => clickItemNav('contactSection')}>
                Contact me
              </S.Button>
            </li>
          </ul>
        </div>
      </S.ContainerMenu>
      <S.ToggleModeSwitch>
        <ToggleModeSwitch className="switch" />
      </S.ToggleModeSwitch>
    </S.ContainerNavbar>
  );
};

export default Navbar;
